import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-3938" />
      <ArchitectureDiagram data-id="element-3939" />
      <HowItWorksConnections mode="how" data-id="element-3940" />
      <LivesInSlack data-id="element-3941" />
      <ComputerUse data-id="element-3942" />
      <CapabilityGrid data-id="element-3943" />
      <NarrativeSection data-id="element-3944" />
      <ToolComparison data-id="element-3945" />
      <WallOfLove data-id="element-3946" />
      <PricingSection data-id="element-3947" />
      <ClosingCTA data-id="element-3948" />
    </>;
}